// Formats the price according to current locale settings.
// eslint-disable-next-line import/prefer-default-export
export function formatPrice(v, relative, locale, currency, includeZero = false) {
    if (!includeZero && v === 0) {
        return '';
    }

    if (v == null || v === '') {
        return '';
    }

    const wholeFormatter = Intl.NumberFormat(locale ?? 'en-US', {
        style: 'currency',
        currencyDisplay: 'narrowSymbol',
        notation: 'standard',
        currency: currency ?? 'USD',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
    });

    const fractionFormatter = Intl.NumberFormat(locale ?? 'en-US', {
        style: 'currency',
        currencyDisplay: 'narrowSymbol',
        notation: 'standard',
        currency: currency ?? 'USD',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    });

    let formatted = v % 1 === 0 ? wholeFormatter.format(v) : fractionFormatter.format(v);

    const localeResolved = (locale ?? '').replace('_', '-').toLowerCase();

    if (localeResolved === 'en-ca') {
        formatted = `C${formatted}`;
    }

    if (relative) {
        if (formatted.startsWith('-')) {
            return formatted;
        }

        return `+${formatted}`;
    }

    return formatted;
}
